import React from 'react';
import { useQuery } from '@apollo/client';
import { useUser } from './useUser';
import { GET_USER_POINTS } from '../graphql/queries';
import { Benefit, User } from '../models';

export function useClientPoints() {
  const [points, setPoints] = React.useState<number>(0);
  const [pointsSelectedInCheckout, setPointsSelectedInCheckout] =
    React.useState<number>(0);
  const [benefits, setBenefits] = React.useState<Benefit[]>([]);
  const [user] = useUser();

  const { data: dataGetUserPoints, loading: loadingGetUserPoints } = useQuery<{
    getUserTotalPoints: {
      user: User;
      benefits: Benefit[];
      totalPoints: number;
    };
  }>(GET_USER_POINTS, {
    variables: {
      data: {
        userId: user?._id,
      },
    },
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    if (!loadingGetUserPoints) {
      setPoints(dataGetUserPoints?.getUserTotalPoints.totalPoints || 0);
      setBenefits(dataGetUserPoints?.getUserTotalPoints.benefits || []);
    }
  }, [dataGetUserPoints]);
  return {
    points,
    loadingGetUserPoints,
    pointsSelectedInCheckout,
    setPointsSelectedInCheckout,
    benefits,
    setBenefits,
  };
}
